import {Link, useNavigate} from 'react-router-dom';
import {useEffect, useState} from 'react'
import api from '../../services/api';
import Alert from '../../components/layout/Alert';
import {cnpj, cpf} from 'cpf-cnpj-validator';
import Table from '../../components/table/Table';
import LinkView from '../../components/table/LinkView';
import LinkEdit from '../../components/table/LinkEdit';
import LinkDelete from '../../components/table/LinkDelete';
import Spinner from '../../components/button/Spinner';
import Tooltip from "../../components/layout/Tooltip";

export default function UserTable() {
    const [showModal, setShowModal] = useState(false);
    const [users, setUsers] = useState([]);
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertColor, setAlertColor] = useState('red');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [search, setSearch] = useState('');
    useEffect(() => {
        setShowModal(false);
        // setShowAlert(false);
        setLoading(true);
        api
            .get('users')
            .then((response) => setUsers(response.data.result))
            .catch((err) => {
                setAlertMessage('Erro ao buscar dados');
                setAlertColor('red');
                setShowAlert(true)
                console.error(err);
            })
            .finally(() => setLoading(false));

        return setUsers([]);
    }, []);

    const handleDelete = (id) => {
        setShowModal(false);
        setLoading(true);
        api
            .delete('users/' + id)
            .then(() => {
                setAlertColor('blue');
                setAlertMessage('Removido com sucesso');
                setUsers(users.filter((user) => user.id !== id));
            })
            .catch((err) => {
                setAlertColor('red');
                if (err.response.status && err.response.status !== 500) {
                    if (err.response.data.message) {
                        setShowAlert(true)
                        setAlertMessage(err.response.data.message);
                        return;
                    }
                }
                setAlertMessage('Erro ao remover. Por favor tente novamente mais tarde');
                console.error(err);
            })
            .finally(() => {
                setShowAlert(true);
                setLoading(false);

            });
    }
    const handleSearch = () => {
        setLoading(true);
        // setShowAlert(false);
        setShowModal(false);
        setUsers([]);
        api.get('/users?search=' + search)
            .then((response) => {
                setUsers(response.data.result);
            })
            .catch((err) => {
                setAlertMessage('Erro ao buscar dados. Por favor tente novamente mais tarde');
                setAlertColor('red');
                setShowAlert(true)
                console.error(err);
            }).finally(() => setLoading(false));
    }

    return (
        <>
            <div className="pt-10 justify-between flex px-10">
                <div className='text-blue-500 flex'>
                    <button onClick={() => {
                        navigate(-1);
                    }} className="">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mt-1" fill="none" viewBox="0 0 24 24"
                             stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round"
                                  d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"/>
                        </svg>
                    </button>
                    <h2 className="text-3xl font-semibold my-auto ">Usuarios</h2>
                </div>
                <Alert color={alertColor} message={alertMessage} show={showAlert} alertOpen={setShowAlert}/>
                <Spinner className='h-4' loading={loading}/>
                <div>
                </div>
                <div className="inline-flex">
                    <label className="relative m-auto">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             className="h-6 w-6 absolute  pointer-events-none top-1/2 transform -translate-y-1/2 left-3"
                             fill="none" viewBox="0 0 24 24"
                             stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                  d="M8 16l2.879-2.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242zM21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                        </svg>
                        <input
                            onChange={(e) => setSearch(e.currentTarget.value)}
                            placeholder="Pesquisar"
                            required
                            type="text"
                            name="search"
                            id="search"
                            className=" pl-14 focus:outline-none px-4 mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                        />
                    </label>
                    <button onClick={() => handleSearch()}
                            className="relative px-2 m-auto ml-1 bg-blue-700 hover:bg-blue-500 text-white
                             font-bold p-2 rounded">
                        Pesquisar
                    </button>
                    <Link to="new"
                          className="relative px-2 m-auto ml-1 bg-red-700 hover:bg-red-500 text-white font-bold p-2 rounded">
                        Cadastrar
                    </Link>
                </div>
            </div>
            <Table>
                <thead className="border-b bg-stone-200">
                <tr className="text-sm text-gray-900 text-center">
                    <th scope="col" className="font-medium py-4">Id</th>
                    <th scope="col" className="font-medium">Nome</th>
                    <th scope="col" className="font-medium">Email</th>
                    <th scope="col" className="font-medium">Documento</th>
                    <th scope="col" className="font-medium">ERP Codigo</th>
                    <th scope="col" className="font-medium w-1/12" colSpan="4">Ações</th>
                </tr>
                </thead>
                <tbody>
                {users.map((user) => (
                    <tr className="text-sm text-gray-900 text-center odd:bg-white even:bg-gray-100" key={user.id}>
                        <td className="py-4">{user.id}</td>
                        <td>{user.name}</td>
                        <td>{user.email}</td>
                        <td>{user.document?.length === 11 ? cpf.format(user.document) : cnpj.format(user.document)}</td>
                        <td>{user.erpCode}</td>
                        <td>
                            <Link className="group" to={'/billets?document=' + user.document}>
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     className="h-6 w-6"
                                     fill="none"
                                     viewBox="0 0 24 24"
                                     stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                          d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
                                </svg>
                                <Tooltip text='Boletos'/>
                            </Link>
                        </td>
                        <td><LinkView linkTo={`${user.id}/view`}/></td>
                        <LinkEdit linkTo={`${user.id}/edit`} showEdit={true}/>
                        <LinkDelete
                            showDelete={true}
                            handleDelete={handleDelete}
                            id={user.id}
                            showModal={showModal}
                            setShowModal={setShowModal}
                        />
                    </tr>
                ))}
                </tbody>
            </Table>
        </>
    )
}
